
export const taskStatus =  Object.freeze({
  'IN_PROGRESS': 'IN_PROGRESS',
  'COMPLETED': 'COMPLETED',
  'FAILED': 'FAILED'
})